export default __webpack_public_path__ + "static/media/16-100.6aac2b26.jpg";